module.exports = __webpack_public_path__ + "assets/fe4be0efb116b5a4de3919701eef8a2b.mp3";